import { useLocation, useNavigate } from "react-router-dom";

// components imports
import ICONS from "../../../../assets/Icons";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import CardActionableButton from "../../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../_utils/IfscLogoMapper";
import TickerAnimation from "../../../_utils/TickerAnimation";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { useSelector } from "react-redux";

const InternalAccountGridView = ({
  id,
  data,
  isSidebarOpen,
  isPopoverOpen,
  internalAccount,
  accountType,
  type,
  typepop,
  flow,
  handleButtonClick,
  associateAccount,
  associateTxn,
  setOpenBeneAssociate,
  beneAccountId,
  txnPayLoad,
  scheduleIntenralTxn,
  isLabelClicked,
  LabelAccounts,
  handleLabelSelect,
  setlableInput,
  filterRef,
  onCardNavigate,
  setIsalertPopup,
  setFlowSelectedId,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { services } = useSelector((state) => state.refreshToken);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  return (
    <div
      style={{
        zIndex: typepop === "popup" && "var(--z-index-content)",
      }}
      className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${
        isSidebarOpen ? "sidebar-open" : ""
      } ${
        data?.filter((item) => item.id !== beneAccountId).length ===
        GlobalConfiguration.lengthCheckZero
          ? "!flex flex-1 items-center justify-center"
          : ""
      }`}
    >
      {data?.filter((item) => item.id !== beneAccountId).length >
      GlobalConfiguration.lengthCheckZero ? (
        data
          ?.filter((item) => item.id !== beneAccountId)
          .map((account) => {
            const labelsText = account?.labels?.length
              ? account.labels.join(", ")
              : "Not assigned";
            return (
              <CardContainer
                key={account.id}
                hoverHeight={GlobalConfiguration.beneAccountCardHoverHeight}
                filterRef={filterRef}
                minHeight={GlobalConfiguration.IntAccCardMinHeight}
                context={account}
                isSelected={
                  Array.isArray(LabelAccounts) &&
                  LabelAccounts?.some((item) => item?.id === account?.id)
                }
                isDisabled={
                  account.id === id ||
                  (typepop === "popup" &&
                    !associateAccount &&
                    (account?.approval_status === "blocked" ||
                      account?.approval_status === "archived" ||
                      account?.approval_status === "rejected")) ||
                  (typepop === "popup" &&
                    account?.approval_status !== "blocked" &&
                    account?.approval_status !== "archived" &&
                    account?.approval_status !== "rejected" &&
                    internalAccount === "internalAccount" &&
                    txnPayLoad?.ownerBankAccountNo === account?.bank_acc_no &&
                    txnPayLoad?.ownerBankIFSC === account?.ifsc_code &&
                    txnPayLoad?.ownerPan === account?.pan_no)
                }
                onClickHandler={(e) => {
                  if (
                    typepop === "popup" &&
                    (account?.approval_status === "blocked" ||
                      account?.approval_status === "archived" ||
                      account?.approval_status === "rejected") &&
                    !associateAccount
                  ) {
                    return;
                  } else if (typepop === "popup" && !associateAccount) {
                    if (isLabelClicked) {
                      handleLabelSelect?.(account);
                      setlableInput(false);
                    } else {
                      handleButtonClick(account);
                    }
                  } else {
                    if (!isLabelClicked) {
                      let selection = window.getSelection();
                      if (
                        selection.toString().length ===
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        if (!isSidebarOpen) {
                          const redirectUrl =
                            internalAccount === "internalAccount" ||
                            accountType === "internal"
                              ? `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${account.id}`
                              : `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${account.id}`;
                          if (onCardNavigate) {
                            onCardNavigate(redirectUrl);
                            return;
                          }
                          if (associateAccount) {
                            // setOpenInternalAssociate(false);
                            setOpenBeneAssociate(false);
                          }
                          navigate(redirectUrl, {
                            state: {
                              isViewAll:
                                internalAccount === "internalAccount" ||
                                accountType === "internal"
                                  ? location.pathname ===
                                    "/internal_account_dashboard/internal_account_view_all"
                                    ? true
                                    : false
                                  : location.pathname ===
                                      "/beneficiary_account_dashboard/beneficiary_account_view_all"
                                    ? true
                                    : false,
                            },
                          });
                        }
                      }
                    } else {
                      handleLabelSelect?.(account);
                      setlableInput(false);
                    }
                  }
                }}
              >
                <card-body>
                  <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                    <div className="w-full flex justify-between items-center">
                      <p
                        className="text-font-sm flex-1 truncate font-normal"
                        style={{
                          color: "var(--text-primary)",
                        }}
                      >
                        <TickerAnimation text={account?.name || "N/A"} />
                      </p>

                      <div className="gap-x-gap-sm flex ml-margin-sm justify-end">
                        {isLabelClicked && (
                          <CardActionableButton
                            icon={
                              Array.isArray(LabelAccounts) &&
                              LabelAccounts?.some(
                                (item) => item?.id === account?.id,
                              )
                                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                            }
                            isDisabled={false}
                          />
                        )}
                      </div>
                    </div>

                    <p className="text-font-xs transform-none text-text-secondary">
                      Account name
                    </p>
                  </div>
                  <div className="flex gap-x-gap-sm justify-between items-center">
                    <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                      <p className="text-font-sm text-text-primary flex-1 truncate font-normal pl-padding-sm">
                        <TickerAnimation
                          text={formatAccountNumber(account.bank_acc_no)}
                        />
                      </p>

                      <p className="text-font-xs text-text-secondary pl-padding-sm">
                        Account number
                      </p>
                    </div>

                    <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                      <div className="Qsmd:w-banklogo-width-sm Qsmd:h-banklogo-height-sm w-banklogo-width-mobile h-banklogo-height-mobile flex-shrink-0">
                        <IfscCodeMapper ifscCode={account?.ifsc_code} />
                      </div>
                    </div>
                  </div>
                </card-body>

                <card-hover>
                  <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                    <div className="w-full flex justify-between items-center">
                      <p
                        className="text-font-sm flex-1 truncate font-semibold"
                        style={{
                          textTransform: "capitalize",
                          color: getStatusColor(account?.approval_status),
                        }}
                      >
                        {services?.includes("IAAccount") &&
                        account?.approval_status === "pending"
                          ? "Require approval"
                          : account?.approval_status || "N/A"}
                      </p>
                    </div>

                    <p className="text-font-xs transform-none text-text-secondary">
                      Account status
                    </p>
                  </div>

                  <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                    <div className="w-full flex justify-between items-center">
                      <p
                        className="text-font-sm flex-1 truncate font-normal"
                        style={{
                          color: "var(--text-primary)",
                        }}
                      >
                        <TickerAnimation text={labelsText} />
                      </p>

                      <div className="gap-x-gap-sm flex ml-margin-sm justify-end">
                        <CardActionableButton
                          icon={ICONS?.LABEL}
                          isDisabled={undefined}
                        />
                      </div>
                    </div>
                  </div>
                </card-hover>
              </CardContainer>
            );
          })
      ) : (
        <div className="flex flex-col items-center justify-center m-auto w-full h-full">
          <img
            src={ICONS?.NO_DATA_FOUND}
            alt="No accounts found"
            className="opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
          />
          <p className="text-text-primary">No data found.</p>
        </div>
      )}
    </div>
  );
};

export default InternalAccountGridView;
